"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BADGE_COLORS = void 0;
var BADGE_COLORS = {
  calypso: 'is--color-calypso',
  sorbet: 'is--color-sorbet',
  lorax: 'is--color-lorax',
  marigold: 'is--color-marigold',
  'candy-apple': 'is--color-candy-apple',
  norman: 'is--color-norman',
  thunderdome: 'is--color-thunderdome',
  oz: 'is--color-oz'
};
exports.BADGE_COLORS = BADGE_COLORS;